export default "__VITE_ASSET__CSfywpJ2__"